import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { DialogComponent } from './dialog/dialog.component';
import { DialogUploadingComponent } from './dialog-uploading/dialog-uploading.component';
import { DialogLargeComponent } from './dialog-large/dialog-large.component';
import { DialogExtraLargeComponent } from './dialog-extra-large/dialog-extra-large.component';

export {
  HeaderComponent,
  FooterComponent,
  DialogComponent,
  DialogUploadingComponent,
  DialogLargeComponent,
  DialogExtraLargeComponent,
};

export default [
  HeaderComponent,
  FooterComponent,
  DialogComponent,
  DialogUploadingComponent,
  DialogLargeComponent,
  DialogExtraLargeComponent,
];
